function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m511.514 438.054-102.388-102.375c4.302-11.801 6.652-24.532 6.652-37.802 0-14.282-2.72-27.94-7.668-40.485v-157.994h-30v-60h-188.873l-41.014-32.177h-148.223v327.416c0 24.486 19.624 44.946 43.746 45.607.426.012.851.018 1.275.018h.121 186.155c19.598 17.577 45.476 28.285 73.811 28.285 13.255 0 25.973-2.345 37.762-6.638l102.396 102.383zm-451.514-102.792c0 4.084-1.613 7.903-4.542 10.753-2.927 2.847-6.793 4.348-10.891 4.241-8.032-.22-14.567-7.227-14.567-15.619v-297.416h107.859l41.014 32.177h169.237v30h-288.11zm30 0v-205.864h288.11v85.375c-19.499-17.15-45.056-27.568-73.003-27.568-61.024 0-110.671 49.646-110.671 110.671 0 18.94 4.786 36.782 13.206 52.386h-120.185c1.672-4.749 2.543-9.802 2.543-15zm134.437-37.385c0-44.482 36.189-80.671 80.671-80.671s80.671 36.188 80.671 80.671-36.189 80.671-80.671 80.671-80.671-36.189-80.671-80.671zm169.878 65.417 74.769 74.76-23.819 23.814-74.771-74.762c9.096-6.682 17.135-14.719 23.821-23.812z",
  fill: "white"
}));

const SvgDirectorySidebar = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Capa_1",
  enableBackground: "new 0 0 511.514 511.514",
  height: 32,
  viewBox: "0 0 511.514 511.514",
  width: 32,
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDirectorySidebar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/directory_sidebar.5d2b571d.svg";
export { ForwardRef as ReactComponent };